import { Route, Routes } from 'react-router';
import { lazy, Suspense } from 'react';
import { PublicRoute } from './PublicRoute';
import { AuthLoading } from '@src/components';
import {
  ROUTE_FORGET_PASSWORD,
  ROUTE_FORGET_PASSWORD_SUCCESS,
  ROUTE_REGISTER,
} from '@src/constants/URLS.const';
import { ForgotPasswordSuccessful } from '@src/pages/Auth/ForgotPasswordSuccessful';

export function AuthenticationRoutes() {
  const SignUp = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.SignUp,
    }))
  );

  const SignIn = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.SignIn,
    }))
  );

  const ForgotPassword = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.ForgotPassword,
    }))
  );
  return (
    <Suspense fallback={<AuthLoading />}>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route index element={<SignIn />} />
          <Route path={ROUTE_REGISTER} element={<SignUp />} />
          <Route path={ROUTE_FORGET_PASSWORD} element={<ForgotPassword />} />
          <Route
            path={`${ROUTE_FORGET_PASSWORD}/${ROUTE_FORGET_PASSWORD_SUCCESS}`}
            element={<ForgotPasswordSuccessful />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}
